<tds-card header="Editing Truck" image-placement="above-header" body-divider="true">
  <div slot="body">
    <form [formGroup]="formTruckEdit" novalidate>
      <div class="fields-form">
        <div class="tds-row">
          <tds-text-field ngDefaultControl label-position="outside" formControlName="Id" type="text" label="ID" />
          <tds-text-field ngDefaultControl label-position="outside" formControlName="Name" type="text" label="Name" />
          <tds-text-field
            ngDefaultControl
            label-position="outside"
            formControlName="FuelType"
            type="text"
            label="Fuel Type"
          />
          <tds-text-field
            ngDefaultControl
            label-position="outside"
            formControlName="NumberOfAxis"
            type="text"
            label="Number Of Axis"
          />
        </div>
      </div>
    </form>
  </div>
  <div slot="actions">
    <tds-button type="primary" size="sm" text="Save Changes" (click)="saveChanges()" />
  </div>
</tds-card>
